// ----------------------------------------------------------------------
// <copyright file="Izenda.UserAccountConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------
//

import localizer from 'share/localization/Izenda.Localizer';

const ADD_USER_TABLE_DEF = {
  selected: { key: 'selected', width: 30, title: '', sortable: false, columnKey: 'selected ', fixed: true },
  fullName: {
    key: 'fullName',
    width: 250,
    get title() {
      return localizer.getText('USER_LABEL_USER_NAME');
    },
    sortable: true,
    columnKey: 'fullName',
    fixed: true
  },
  emailAddress: {
    key: 'emailAddress',
    width: 250,
    get title() {
      return localizer.getText('USER_LABEL_EMAIL_ADDRESS');
    },
    sortable: true,
    columnKey: 'emailAddress',
    fixed: true
  },
  roles: {
    key: 'roles',
    width: 320,
    get title() {
      return localizer.getText('USER_LABEL_ROLE');
    },
    sortable: false,
    columnKey: 'roles'
  }
};

const SEARCH_OPTIONS = [
  {
    value: 'all',
    get label() {
      return localizer.getText('USER_LABEL_ALL');
    }
  },
  {
    value: 'fullName',
    get label() {
      return localizer.getText('USER_LABEL_USER_NAME');
    }
  },
  {
    value: 'emailAddress',
    get label() {
      return localizer.getText('USER_LABEL_EMAIL_ADDRESS');
    }
  },
  {
    value: 'role',
    get label() {
      return localizer.getText('USER_LABEL_ROLE');
    }
  }
];

export default {
  DEFAULT_VALUE: {
    SEARCH_CRITERIA: 'all',
    SORT_DIRS: {
      fullName: 'DESC'
    }
  },
  ADD_USER_TABLE_DEF,
  SEARCH_OPTIONS,
  PASSWORD_OPSTIONS: {
    EMAIL_NEW_PASSWORD_CONSTRAINTS: {
      presence: {
        presence: true,
        get message() {
          return localizer.getText('USER_MESSAGE_FIELD_IS_REQUIRED');
        }
      }
    },
    get SEND_PASSWORD() {
      return localizer.getText('USER_MESSAGE_SEND_PASSWORD');
    },
    get EMAIL() {
      return localizer.getText('USER_MESSAGE_EMAIL');
    }
  },
  USER_STATE: {
    get ACTIVATE() {
      return localizer.getText('USER_STATE_ACTIVATE');
    },
    get DEACTIVATE() {
      return localizer.getText('USER_STATE_DEACTIVATE');
    }
  },
  MESSAGE: {
    get DEACTIVE() {
      return localizer.getText('USER_MESSAGE_DEACTIVE');
    },
    get DELETE() {
      return localizer.getText('USER_MESSAGE_DELETE');
    },
    get LAST_SYSTEM_ADMIN() {
      return localizer.getText('USER_MESSAGE_DELETE_LAST_SYSTEM_ADMIN');
    }
  },
  INACTIVE_REASON: {
    get 1() {
      return localizer.getText('USER_INACTIVE_REASON_ACTIVE');
    },
    get 2() {
      return localizer.getText('USER_INACTIVE_REASON_INACTIVE_USER');
    },
    get 3() {
      return localizer.getText('USER_INACTIVE_REASON_INACTIVE_PASSWORD');
    },
    get 4() {
      return localizer.getText('USER_INACTIVE_REASON_INACTIVE_LOGIN');
    },
    get INTEGRATION() {
      return localizer.getText('USER_INACTIVE_REASON_INTEGRATION');
    }
  },
  NUMBER_INACTIVE_REASON_STATUS: {
    ACTIVE: 1,
    DEACTIVATED: 2,
    NO_PASSWORD_SET: 3,
    FAILED_LOGIN: 4
  },
  USER_SETUP_CONSTRAINTS: {
    USER_ID: {
      presence: {
        presence: true,
        get message() {
          return localizer.getText('USER_MESSAGE_USER_ID_IS_REQUIRED');
        }
      }
    },
    FIRST_NAME: {
      presence: {
        presence: true,
        get message() {
          return localizer.getText('USER_MESSAGE_FIRST_NAME_IS_REQUIRED');
        }
      }
    },
    LAST_NAME: {
      presence: {
        presence: true,
        get message() {
          return localizer.getText('USER_MESSAGE_LAST_NAME_REQUIRED');
        }
      }
    },
    ROLE: {
      presence: {
        presence: true,
        get message() {
          return localizer.getText('USER_MESSAGE_ROLE_IS_REQUIRED');
        }
      }
    },
    RECIPIENTS: {
      presence: {
        presence: true,
        get message() {
          return localizer.getText('USER_MESSAGE_RECIPIENT_IS_REQUIRED');
        }
      }
    },
    EMAIL: {
      format: {
        pattern: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
        message(value, attribute, validatorOptions, attributes, globalOptions) {
          return localizer.getText('ACCOUNT_CONSTANTS_MESSAGE_INVALID_EMAIL');
        }
      }
    }
  },
  VALIDATE_RESULT_ROLE_ASSOCIATION_KEYS: {
    get InvalidReportInVisibleCategoiesKey() {
      return localizer.getText('USER_SETUP_ERROR_ROLE_REPORT_ASSOCIATION_EDITABLE');
    },
    get InvalidReportInSavableCategoiesKey() {
      return localizer.getText('USER_SETUP_ERROR_ROLE_REPORT_ASSOCIATION_ACCESSIBLE');
    },
    get InvalidDashboardVisibleCategoiesKey() {
      return localizer.getText('USER_SETUP_ERROR_ROLE_DASHBOARD_ASSOCIATION_EDITABLE');
    },
    get InvalidDashboardSavableCategoiesKey() {
      return localizer.getText('USER_SETUP_ERROR_ROLE_DASHBOARD_ASSOCIATION_ACCESSIBLE');
    }
  },
  USER_LIST_SEARCH_KEY: 'FullName'
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.UserAccountConstants.js